import React from 'react'
import { FormattedMessage } from 'react-intl'

/**
 * React-Intl v3 changed the return type of <FormmattedMessage /> from any to ReactNode.
 * This function aliases the return type from ReactNode to string so it is backward compatiable.
 * React-Intl v4 changed the return type fo ReactNodeArray, so we spread the msg in for children
 */
export function ContrastFormattedMessage({ children, ...props }) {
  return <FormattedMessage {...props} children={(msg) => children(...msg)} />
}
